document.addEventListener('DOMContentLoaded', () => {
  const shareBtn = document.getElementById('lsbShareBtn');
  
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({
            title: document.title,
            url: window.location.href
          });
        } catch (err) {
          console.log('Share canceled/failed', err);
        }
      } else {
        // Fallback: Copy Link
        navigator.clipboard.writeText(window.location.href).then(() => {
          const originalText = shareBtn.innerHTML;
          shareBtn.innerText = 'Copied!';
          setTimeout(() => {
            shareBtn.innerHTML = originalText;
          }, 2000);
        });
      }
    });
  }
});